import { collection, deleteDoc, doc, getDocs } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { db } from '../firebase.config';
import { MultiLevelSidebar } from '../Components/Layout/Sidebar';
import HomeBanners from '../Components/HomeContent/HomeBanners';


const HomeBannerList = () => {
    const [events, setEvents] = useState([])
    const fetchProperties = async () =>{
      const querySnapshot = await getDocs(collection(db, "homeProperties"));
      querySnapshot.forEach((doc) => {
       setEvents((prev)=>[...prev,{
        id:doc.id,
        ...doc.data()
       }])
     
    
      });
    }
    const deleteProperty = async (id) =>{
       await deleteDoc(doc(db, "homeProperties", id))
      window.location.reload()
    
    }
    useEffect(() => {
     fetchProperties()
    }, [])
  return (
    <div>
        <MultiLevelSidebar />
        <HomeBanners deleteBanners={deleteProperty} homeBanners={events}  />
    </div>
  )
}

export default HomeBannerList